import React from 'react'
// import cors from 'cors';
import { Link,useLocation,useNavigate } from 'react-router-dom';
// import { FaCalendarDay } from "react-icons/fa";
// import { FaPlay } from "react-icons/fa";
// import Player from './Player';
import Modal from 'react-bootstrap/Modal';
import { useState, useEffect, useRef } from 'react';
import {useParams} from 'react-router-dom';

import Podcastblock from '../component/Podcastblock';
import podcastdata from '../assets/music/getPodcast.json'

// import axios from 'axios';
// import xmldata from '../assets/music/podcast.xml'






// import useSound from "use-sound";
// import { AiFillPlayCircle, AiFillPauseCircle } from "react-icons/ai";
// import { BiSkipNext, BiSkipPrevious } from "react-icons/bi";
// import { IconContext } from "react-icons";

import { FaBackward } from "react-icons/fa";
import { FaPauseCircle } from "react-icons/fa";
import { FaPlayCircle } from "react-icons/fa";
import { FaForward } from "react-icons/fa";

import { FaCalendarDay } from "react-icons/fa";
import { FaPlay } from "react-icons/fa";



export default function Categorypage() {

    const {categoryname} = useParams();
    
    const navigate = useNavigate();
    const [modalShow, setModalShow] = useState(false);
    const { hash } = useLocation();
   
   
        
      
     







    //  const [podcastdata, setPodcastdata] = useState(null);


//     const [isPlaying, setIsPlaying] = useState(false);

//     const [musicImage, setMusicImage] = useState(false);
//     const [musicTitle, setMusicTitle] = useState(false);
//     const [musicDesc, setMusicDesc] = useState(false);
//     const [musicMp3, setMusicMp3] = useState(false);


//   const [time, setTime] = useState({
//     min: "",
//     sec: ""
//   });
//   const [currTime, setCurrTime] = useState({
//     min: "",
//     sec: ""
//   });

//   const [seconds, setSeconds] = useState();

//   const [play, { pause, duration, sound }] = useSound(musicMp3);

//   useEffect(() => {
//     if (duration) {
//       const sec = duration / 1000;
//       const min = Math.floor(sec / 60);
//       const secRemain = Math.floor(sec % 60);
//       setTime({
//         min: min,
//         sec: secRemain
//       });
//     }
//   }, [isPlaying]);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       if (sound) {
//         setSeconds(sound.seek([]));
//         const min = Math.floor(sound.seek([]) / 60);
//         const sec = Math.floor(sound.seek([]) % 60);
//         setCurrTime({
//           min,
//           sec
//         });
//       }
//     }, 1000);
//     return () => clearInterval(interval);
//   }, [sound]);

//   const playingButton = () => {
//     if (isPlaying) {
//       pause();
//       setIsPlaying(false);
//     } else {
//       play();
//       setIsPlaying(true);
//     }
//   };

//   const loadMusic =(image,title,mp3)=>{
//     useSound(mp3);
//     setMusicImage(image);
//     setMusicTitle(title);
//    // setMusicDesc();
//     // setMusicMp3();
//   }


const [isPlaying, setIsPlaying] = useState(false);
  const [currentTrack, setCurrentTrack] = useState(0);
  const [tracks, setTracks] = useState(podcastdata);


  const [audioProgress, setAudioProgress] = useState(0);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  
  const [musicTotalLength, setMusicTotalLength] = useState('04 : 38');
  const [musicCurrentTime, setMusicCurrentTime] = useState('00 : 00');
  




  const currentAudio = useRef(null);

//   useEffect(() => {
//     currentAudio.current = tracks[currentTrack].src;
//     currentAudio.current.autoplay = true;
//   }, []);

  useEffect(() => {
    if (currentAudio.current) {
      currentAudio.current.pause();
      currentAudio.current.currentTime = 0;
      setMusicCurrentTime('00:00');
      setAudioProgress(0);
      setMusicTotalLength(podcastdata[currentTrack].duration);
      currentAudio.current.src = podcastdata[currentTrack].enclosure.url;
      currentAudio.current.play();
      
      setIsPlaying(true);
    }
    setMusicCurrentTime('00:00');
    setAudioProgress(0);
    setMusicTotalLength(podcastdata[currentTrack].duration);
    setIsPlaying(false);
  }, [currentTrack]);

  
  useEffect( () => {
    if(hash){
    setModalShow(true);
    const selectMusic = hash.replace('#isw', '');

    setCurrentTrack(selectMusic);

    }
  }, [hash]);



  const handlePlayPause = () => {
    if (isPlaying) {
      currentAudio.current.pause();
    } else {
      currentAudio.current.play().catch((error) => {
        console.error(error);
      });
    }
    setIsPlaying(!isPlaying);
  };

  const handleNextTrack = () => {
    setCurrentTrack((prevTrack) => (prevTrack + 1) % tracks.length);
    setIsPlaying(true);
  };

  const handlePrevTrack = () => {
    setCurrentTrack((prevTrack) => (prevTrack - 1 + tracks.length) % tracks.length);
  };

  const handleTrackChange = (index) => {
    setCurrentTrack(index);
  };



  const handleClose = () => {setModalShow(false);navigate('#');
  setIsPlaying(false);
  //   pause();
  //   setIsPlaying(false);
   }


   const handleMusicProgressBar = (e)=>{
    setAudioProgress(e.target.value);
    currentAudio.current.currentTime = e.target.value * currentAudio.current.duration / 100;
  }

  //Change Avatar Class
  let avatarClass = ['objectFitCover','objectFitContain','none']
  const [avatarClassIndex, setAvatarClassIndex] = useState(0)
  const handleAvatar = ()=>{
    if (avatarClassIndex >= avatarClass.length - 1) {
      setAvatarClassIndex(0)
    }else{
      setAvatarClassIndex(avatarClassIndex + 1)
    }
  }


  
  const handleAudioUpdate = ()=>{
    //Input total length of the audio
    let minutes = Math.floor(currentAudio.current.duration / 60);
    let seconds = Math.floor(currentAudio.current.duration % 60);
    let musicTotalLength0 = `${minutes <10 ? `0${minutes}` : minutes} : ${seconds <10 ? `0${seconds}` : seconds}`;
    setMusicTotalLength(musicTotalLength0);

    //Input Music Current Time
    let currentMin = Math.floor(currentAudio.current.currentTime / 60);
    let currentSec = Math.floor(currentAudio.current.currentTime % 60);
    let musicCurrentT = `${currentMin <10 ? `0${currentMin}` : currentMin} : ${currentSec <10 ? `0${currentSec}` : currentSec}`;
    setMusicCurrentTime(musicCurrentT);

    const progress = parseInt((currentAudio.current.currentTime / currentAudio.current.duration) * 100);
    setAudioProgress(isNaN(progress)? 0 : progress)
  }




  return (
    <>
        
   
    
   
    
   
    <section className="trending_sec">
        <div className="container">
            <div className="row">
                <div className="col-sm-12">
                    <div className="section_title bg_black" data-title="Category Podcast">
                        <h1 className="section_tText cat-name">{categoryname} Podcasts</h1>
                        <p>We create an innovative journey so that your <b>press release podcasts</b> rank higher and gain more listeners at the same time. Be it a business announcement or any relevant event, we cover everything with skills and experience.</p>
                    <p>Publish your latest <b>audio press release</b> and receive more credibility. We adhere to engaging you with the best audio press release distribution services for better media coverage. Purchase our new PR podcast services and explore the profit differently. Being the most extensive as well as a trusted distribution network, we keep boosting your rank amongst the millions.</p>
                <p style={{height:"40px"}}></p>    
                </div>
                </div>
                {
                                          podcastdata.map((gridvalue,index) => {
                                            return (
                                               <div className="col-sm-12" onClick={() => handleTrackChange(index)}>
                                               <div className="trending_big">
                                                   <div className="trnding_wrapper">
                                                       <div className="playbtn"><Link to={"#isw"+index} style={{ textDecoration: 'none' }} ><FaPlay /></Link></div>
                                                       <Link to={"#isw"+index} className="trending_big_img" >
                                                           <img src={gridvalue.image.href} loading="lazy" alt="" className="img-fluid" title="" />
                                                       </Link>
                                                   </div>
                                                   <div className="trending_big_content">
                                                       <p className="trending_date"><FaCalendarDay /> {gridvalue.pubDate} </p>
                                                       <Link to={"#isw"+index} title="" className="b_trendingtext" >{gridvalue.title}</Link>
                                                       <p className="trending_para">{gridvalue.description}</p>
                                                   </div>
                                               </div>
                                           </div>
                                            )
                                        })
                                     }
                

 
                
            
                
                
                                     </div>
                                     </div>
                                     <br/><br/>
                                 </section>
    
    
    


     {/* player modal start */}


     <Modal

size="md"
aria-labelledby="contained-modal-title-vcenter"
centered show={modalShow}
onHide={handleClose}

>

<Modal.Header closeButton closeVariant="white">

</Modal.Header>
<Modal.Body >
<div className="container">
      <audio src={tracks[currentTrack].enclosure.url} ref={currentAudio} onEnded={handleNextTrack} onTimeUpdate={handleAudioUpdate} ></audio>
      
      
      <div className="music-Container">
        <p className='musicPlayer'>Music Player</p>
        <p className='music-Head-Name'>{tracks[currentTrack].title}</p>
        
        <img src={tracks[currentTrack].image.href} className={avatarClass[avatarClassIndex]} onClick={handleAvatar} alt="song Avatar" id='songAvatar'/>
        <div className="musicTimerDiv">
          <p className='musicCurrentTime'>{musicCurrentTime}</p>
          <p className='musicTotalLenght'>{musicTotalLength}</p>
        </div>
        <input type="range" name="musicProgressBar" className='musicProgressBar' value={audioProgress} onChange={handleMusicProgressBar} />
        <div className="musicControlers">
         

<FaBackward className=' musicControler' onClick={handlePrevTrack} />
{isPlaying? <FaPauseCircle className='musicControler' onClick={handlePlayPause} /> : <FaPlayCircle className=' musicControler' onClick={handlePlayPause} />}
<FaForward className=' musicControler' onClick={handleNextTrack} /> 





        </div>
      </div>
     
     
    </div>

  
<br/>
</Modal.Body>

</Modal>




{/* player modal close */}
    
    </>
  )
}
